import { useTranslation } from "react-i18next";
import { ScanFace } from "lucide-react";
import { useAvatarEntry } from "./useAvatarEntry";

// The landing page's way in to avatars (the corrido and ads pitches, beside
// their start button): "Create your avatar", to the avatar section on the
// account page (signed out: sign up first, then back there). Nothing at all
// where the server says avatars are not on for this visitor (useAvatarEntry).
// A plain link: the pitch also renders outside a router (its tests).

export default function AvatarEntryLink({ className = "", source }: { className?: string; source: string }) {
  const { t } = useTranslation();
  const { show, href } = useAvatarEntry();
  if (!show) return null;
  return (
    <a href={href} data-testid={`avatar-entry-${source}`} className={className}>
      <ScanFace className="h-4 w-4 shrink-0" aria-hidden />
      {t("faceLock.entry.cta")}
    </a>
  );
}
